import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { grantCookieConsent, revokeCookieConsent, trackEvent } from '../utils/matomoTracker';
import './CookieConsent.css';

const SSO_URL = process.env.REACT_APP_SSO_URL || 'https://auth.yuuu.es';

const CookieConsent = () => {
  const { t, i18n } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Migrate old localStorage key
    const oldConsent = localStorage.getItem('cookiesAccepted');
    if (oldConsent) {
      localStorage.setItem('cookieConsent', 'accepted');
      localStorage.removeItem('cookiesAccepted');
      grantCookieConsent();
      return;
    }

    const cookieChoice = localStorage.getItem('cookieConsent');
    if (!cookieChoice) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    grantCookieConsent();
    trackEvent('consent', 'accepted');
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    trackEvent('consent', 'rejected');
    revokeCookieConsent();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-consent-container">
        <p className="cookie-consent-text">
          {t('policies.cookieConsent')}{' '}
          <a href={`${SSO_URL}/legal/cookies?lang=${i18n.language}`}
             target="_blank" rel="noopener noreferrer"
             className="cookie-consent-link">
            {t('policies.moreInfo', 'More info')}
          </a>
        </p>
        <div className="cookie-consent-buttons">
          <button className="cookie-consent-button cookie-consent-reject" onClick={handleReject}>
            {t('policies.rejectButton', 'Reject')}
          </button>
          <button className="cookie-consent-button cookie-consent-accept" onClick={handleAccept}>
            {t('policies.acceptButton')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
